import React from 'react';
import CheckboxGroupEdit from '@atlassian/jira-issue-field-checkbox/src/ui/edit/index.tsx';
import { mapDataToOptions } from '@atlassian/jira-issue-field-checkbox/src/ui/edit/utils.tsx';
import { FieldContainer } from '../../common/ui/fields/styled.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import { validateCheckboxField } from '../../common/utils/validators/index.tsx';
import type { Props, CheckboxFieldConfig, FieldValue } from './types.tsx';

const CheckboxField = (props: Props) => {
	const {
		width,
		fieldProps: { value, onChange },
		error,
		allowedValues,
		fieldId,
		isReadOnly = false,
	} = props;

	const options = mapDataToOptions(allowedValues);
	return (
		<FieldContainer width={width}>
			<CheckboxGroupEdit
				options={options}
				values={value}
				onChange={onChange}
				isInvalid={Boolean(error)}
				isDisabled={isReadOnly}
				fieldId={fieldId}
			/>
		</FieldContainer>
	);
};

export default withFormField({
	validator: validateCheckboxField,
	transformDefaultValue: mapDataToOptions,
	// @ts-expect-error - TS2345 - <Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<CheckboxSelectFieldConfig, Options>, any>'>
})<CheckboxFieldConfig, FieldValue>(CheckboxField);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { mutateCheckboxField } from './utils';
